import { Component, OnDestroy, OnInit } from "@angular/core";
import { FormIOInboxService } from "./formio-inbox.service";
import { MessageService } from "primeng/api";
import { Message } from "@bbwt/classes";
import { CurrentUserChangedData, UserService } from "@main/users";
import { BroadcastService } from "@bbwt/modules/broadcasting";
import { AppOnlineStateService } from "@main/pwa/app-online-state.service";
import { Router } from "@angular/router";
import { Subject, takeUntil } from "rxjs";

@Component({
    selector: "formio-inbox-indicator",
    templateUrl: "./formio-inbox-indicator.component.html",
    styleUrls: ["./formio-inbox-indicator.component.scss"]
})
export class FormIOInboxIndicatorComponent implements OnInit, OnDestroy {
    inboxItemsCount: number = 0;
    private readonly destroyed$ = new Subject<void>();

    constructor(
        private _formInboxService: FormIOInboxService,
        private messageService: MessageService,
        public userService: UserService,
        private broadcastService: BroadcastService,
        private router: Router
    ){
        this._formInboxService.newItems.subscribe((result: number) => {
            this.inboxItemsCount = result;
        });

        this._formInboxService.getError.subscribe((error: string) => {
            this.messageService.add(Message.Error(error));
        });

        this.broadcastService
            .on<CurrentUserChangedData>(UserService.CurrentUserChangedEventName)
            .pipe(takeUntil(this.destroyed$))
            .subscribe(data => {
                this.initItemsCount();
            });
    }

    ngOnInit(): void {
        if (this.userService.isLogged) {
            this.initItemsCount();
        }

        this.broadcastService.on(AppOnlineStateService.AppOnlineStateChanged).subscribe(() => {
            this.initItemsCount();
        });
    }

    ngOnDestroy(): void {
        this.destroyed$.next();
        this.destroyed$.complete();
    }

    initItemsCount() {
        if (this.userService.isLogged) {
            this._formInboxService.checkHubConnection();
            this._formInboxService.getInboxItemsTotal().then(data => (this.inboxItemsCount = data));
        }
    }

    onClick() {
        this.router.navigate(["/formio/list"]);
    }
}